import { render, staticRenderFns } from "./optimiserConfiguration.vue?vue&type=template&id=4ed9faf2&"
import script from "./optimiserConfiguration.vue?vue&type=script&lang=js&"
export * from "./optimiserConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports